export const GUEST = {
  ORDERS: 'guest_orders',
}
